/**
 * Situación de una orden enviada a un actuador.
 *
 * Enviar una orden no es instantáneo: viaja al nodo, este la aplica y devuelve
 * una confirmación. Estos estados describen ese trayecto para que el operador
 * sepa siempre si su orden llegó, y no tenga que deducirlo del silencio.
 */
export const ESTADOS_COMANDO = [
  'inactivo',
  'encolado',
  'pendiente',
  'aplicado',
  'rechazado',
  'sin_respuesta',
  'error',
] as const;

export type EstadoComandoValor = (typeof ESTADOS_COMANDO)[number];

const ETIQUETA: Readonly<Record<EstadoComandoValor, string>> = {
  inactivo: 'Sin órdenes recientes',
  encolado: 'Enviando…',
  pendiente: 'Esperando confirmación…',
  aplicado: 'Aplicado',
  rechazado: 'Rechazado por el equipo',
  sin_respuesta: 'Sin respuesta del equipo',
  error: 'No se pudo enviar',
};

const TOKEN: Readonly<Record<EstadoComandoValor, string>> = {
  inactivo: '--text-3',
  encolado: '--status-info',
  pendiente: '--status-warning',
  aplicado: '--status-success',
  rechazado: '--status-danger',
  sin_respuesta: '--status-danger',
  error: '--status-danger',
};

export class EstadoComando {
  private constructor(readonly valor: EstadoComandoValor) {}

  static from(valor: EstadoComandoValor): EstadoComando {
    return new EstadoComando(valor);
  }

  static inactivo(): EstadoComando {
    return new EstadoComando('inactivo');
  }

  get etiqueta(): string {
    return ETIQUETA[this.valor];
  }

  get color(): string {
    return `var(${TOKEN[this.valor]})`;
  }

  /** La orden está viajando: no conviene enviar otra al mismo actuador. */
  get enCurso(): boolean {
    return this.valor === 'encolado' || this.valor === 'pendiente';
  }

  get fallo(): boolean {
    return this.valor === 'rechazado' || this.valor === 'sin_respuesta' || this.valor === 'error';
  }

  toString(): string {
    return this.valor;
  }
}
